import styled from 'styled-components'
import InputBoxOnChange from '../inputbox/InputBoxOnChange'
import { useAdTeamStore } from 'src/stores/AdTeamStore'
import RegionSelectorAdTeam from './RegionSelectorAdTeam'
import ModalSelectManager from './ModalSelectManager'
import ModalCreateTeamTable from './ModalCreateTeamTable'
import { Divider } from '@mui/material'
import { NextButton } from '../common/CommonStyled'
import AddIcon from '@mui/icons-material/Add';
import { useExtraModalStore } from 'src/stores/ModalStore'
import ExtraModalAddTeamMember from './ExtraModalAddTeamMember'


const PageWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 24px;

    position: relative;
    margin-top: 24px;
    overflow-y: auto;
    max-height: 80vh;
`
const LabelWarpper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;

  width: 612px;
  position:relative;
`

const LabelSpan = styled.div`
  font-size: 18px;
  font-weight: 600;
  /* margin-bottom: auto;
  margin-top: 9.5px; */
  width: 100px;
`

const ElementWrapper = styled.div`
  flex: 1;
`
const LeftHeaderButtonWrapper = styled.div`
    position: absolute;
    right: 5px;
    top: 50%;
    transform: translateY(-50%);
    line-height: normal;
`

const ModalContentCreateTeam = () => {
  const extraModalsetField = useExtraModalStore((state)=>state.setField)
  const setField = useAdTeamStore((state)=>state.setField)
  const team_name = useAdTeamStore((state)=>state.team_name)
  const memberList = useAdTeamStore((state)=>state.memberList)

  const onClickAddTeam = ()=>{
    extraModalsetField('content',<ExtraModalAddTeamMember/>)
    extraModalsetField('width','812px')
    extraModalsetField('padding','30px')
    extraModalsetField('open',true)
  }

  return (
    <PageWrapper>
      <LabelWarpper>
        <LabelSpan><span style={{color:'#09A7D6'}}>*</span> 팀명</LabelSpan>
        <ElementWrapper>
          <InputBoxOnChange value={team_name} onChange={(e)=>setField('team_name',e.target.value)} height='40px' maxLength={10}/>
        </ElementWrapper>
      </LabelWarpper>
      <LabelWarpper style={{alignItems:'strech', minHeight:'40px'}}>
        <LabelSpan style={{display:'flex',flexDirection:'column',justifyContent:'center', height:'100%'}}>
          담당지역
        </LabelSpan>
        <ElementWrapper>
          <RegionSelectorAdTeam/>
        </ElementWrapper>
      </LabelWarpper>
      <LabelWarpper>
        <LabelSpan>팀장</LabelSpan>
        <ModalSelectManager/>
      </LabelWarpper>
      <LabelWarpper>
        <LabelSpan>인원</LabelSpan>
        <span>{memberList.length}명</span>
      </LabelWarpper>
      <Divider sx={{width:'100%', borderColor:'#D1D1D1'}}/>
      <div style={{position:'relative', marginLeft:'auto', height:'44px', marginBottom:'-5px'}}>
        <LeftHeaderButtonWrapper>
          <NextButton style={{width:'112px',maxHeight:'44px', fontSize:'18px', fontWeight:500, gap:'8px'}} onClick={onClickAddTeam}>
              <AddIcon/> 팀 생성
          </NextButton>
        </LeftHeaderButtonWrapper>
      </div>
      <ModalCreateTeamTable/>
    </PageWrapper>
  )
}

export default ModalContentCreateTeam